import { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import { Text } from '@backstage/ui';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--bui-space-2)',
    padding: 'var(--bui-space-2) var(--bui-space-3)',
    border: '1px solid var(--bui-border)',
    borderRadius: 'var(--bui-radius-2)',
  },
  icon: {
    marginTop: 2,
    flexShrink: 0,
    color: 'var(--bui-fg-secondary)',
    display: 'inline-flex',
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
});

export type ChatInformationBoxProps = {
  title: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  className?: string;
};

export const ChatInformationBox = ({
  title,
  icon,
  children,
  className,
}: ChatInformationBoxProps) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)}>
      {icon ? (
        <span className={classes.icon} aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <div className={classes.content}>
        {typeof title === 'string' ? (
          <Text variant="body-small">{title}</Text>
        ) : (
          title
        )}
        {children}
      </div>
    </div>
  );
};
